import type { ChannelType } from '@gr/core/distribution/channels/channel-types';
import { useT } from '../../../app/di';
import { channelOptions, type ChannelOptionSource } from './model/channel-options';

/** CHN-UC-6: варианты выпадающего списка каналов — с платформой в подписи. */
export function useChannelOptions(channels: readonly ChannelOptionSource[]): { value: string; label: string }[] {
  const { t } = useT();
  return channelOptions(channels, (type: ChannelType) => t(`channels.types.${type}`));
}
